
import { defineComponent, computed, ref } from 'vue';
import { useStore } from '@/store';
import { Material } from '@/types/app';
import { alphabetize, lowerCaseIncludes, useModalState } from '@/utils';
import MaterialAddEditFormModal from '@/components/modal/MaterialAddEditFormModal.vue';
import MaterialDeleteFormModal from '@/components/modal/MaterialDeleteFormModal.vue';
import MaterialsTable from '@/components/tables/MaterialsTable.vue';
import ButtonInput from '@/components/form-controls/base/ButtonInput.vue';
import TextInput from '@/components/form-controls/base/TextInput.vue';
import MaterialIconButton from '@/components/form-controls/MaterialIconButton.vue';

export default defineComponent({
  name: 'MaterialsManager',
  components: {
    MaterialAddEditFormModal,
    MaterialDeleteFormModal,
    MaterialsTable,
    ButtonInput,
    TextInput,
    MaterialIconButton
  },
  setup() {
    const store = useStore();
    const searchValue = ref('');
    const materials = computed(() => store.getters.materials.get);
    const filteredMaterials = computed(() =>
      materials.value.filter(material => lowerCaseIncludes(material.name, searchValue.value))
    );

    const sortedMaterials = computed(() => alphabetize(filteredMaterials.value, 'name'));

    const [selectedAddEditMaterial, isAddEditModalOpen, openAddEditModal] = useModalState<Material>();
    const [selectedDeleteMaterial, isDeleteModalOpen, openDeleteModal] = useModalState<Material>();

    return {
      searchValue,
      sortedMaterials,
      selectedAddEditMaterial,
      isAddEditModalOpen,
      openAddEditModal,
      selectedDeleteMaterial,
      isDeleteModalOpen,
      openDeleteModal
    };
  }
});
